import { Col, Input, Row, Select, Space } from "antd";
import { FC } from "react";
import styles from "./index.module.scss";
import { SearchAndFilterProps } from "./types";
import { AddSvg, CancelIcon, SearchSvg } from "utils/svgs";
import { useSelector } from "react-redux";
import { checkPermission } from "utils/utils";

const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
  const {
    performSearchHandler,
    searchValue,
    performStaffFilterHandler,
    performRoleFilterHandler,
    staffFilterValue,
    roleFilterValue,
    roleOptions,
    openDrawerHandler,
    title,
    isSearchCancel,
    setSearch,
    setIsSearchCancel
  } = props;

  const userPermissions = useSelector(
    (state: any) => state?.userProfile?.data?.permissions
  );

  const isAddPermission = checkPermission(userPermissions, {
    permissionName: 'Users',
    permission: ['add'],
  });

  return (
    <div className={styles["search-filter"]}>
      <div className={styles["search-filter__wrapper"]}>
        <Row justify={"space-between"}>
          <Col>
            <div className={styles["search-filter__wrapper--title"]}>{title}</div>
          </Col>
          <Col>
            <Space>
              <Input
                className={styles["search-filter__search"]}
                placeholder="Search by Name and Email"
                prefix={<SearchSvg />}
                onChange={performSearchHandler}
                value={searchValue}
                size="large"
                suffix={
                  isSearchCancel && (
                    <span
                      style={{ display: "flex", cursor: "pointer" }}
                      onClick={() => {
                        setSearch('');
                        setIsSearchCancel(false);
                      }}
                    >
                      <CancelIcon />
                    </span>
                  )
                }
              />
              <Select
                value={roleFilterValue ?? undefined}
                placeholder="All Roles"
                style={{ width: 160, borderRadius: 32 }}
                allowClear
                showSearch
                optionFilterProp="label"
                onChange={(value) => performRoleFilterHandler?.(value ?? null)}
                options={(roleOptions || []).map((role) => ({
                  label: role.name,
                  value: role.id,
                }))}
                size="large"
              />
              <Select
                value={staffFilterValue}
                style={{ width: 160, borderRadius: 32 }}
                onChange={performStaffFilterHandler}
                options={[
                  { label: "Active", value: "true" },
                  { label: "Not Active", value: "false" },
                ]}
                size="large"
              />
              <div className={styles['user-table__action']}>
                {(isAddPermission) && (
                  <button
                    className={`btn-blue ${styles['user-table__action--button']}`}
                    onClick={openDrawerHandler}
                  >
                    <AddSvg />
                    <p>Add User</p>
                  </button>
                )}
              </div>
            </Space>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;
